import React from 'react';
import { Box, keyframes } from '@mui/material';

/**
 * Skeleton shimmer animation for loading states
 * Shows pulsing placeholder lines mimicking text content
 */
const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const SkeletonShimmer = ({ lines = 4, height = '16px', spacing = '12px' }) => {
  return (
    <Box sx={{ py: 2 }}>
      {Array.from({ length: lines }).map((_, idx) => (
        <Box
          key={idx}
          sx={{
            height,
            width: idx === lines - 1 ? '80%' : '100%', // Last line shorter
            mb: idx === lines - 1 ? 0 : spacing,
            background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
            backgroundSize: '200% 100%',
            animation: `${shimmer} 1.5s ease-in-out infinite`,
            borderRadius: '4px'
          }}
        />
      ))}
    </Box>
  );
};

export default SkeletonShimmer;
